import { t } from 'i18n';
import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useNotification } from '../NotificationProvider';
import {
  Flex,
  Shape,
  styled,
  Body,
  Tooltip,
  ButtonIcon,
} from '@teko/ds-desktop';
import { MarkAsReadAlternativeOutlined } from '@teko/ds-icon';
import { getTrackingData } from '@teko/tracking';
import { onNotificationClick } from '../helper';
import { NotificationList } from '../components/NotificationList';
import { useTenantConfig } from 'hooks';
import { SHARED_NAV_ITEMS_HREFS } from 'constants/index';

const Wrapper = styled(Shape)`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  width: 384px;
`;
const LastLinkWrapper = styled(Flex)`
  a {
    color: #a7abc3;
    text-decoration: none;
    &:hover {
      color: #82869e;
    }
  }
`;

const WrapperHeader = styled(Flex)`
  line-height: 24px;
  padding: 10px 16px;
  background-color: #f8f8fc;
`;

const NotificationHeader: React.FC<{
  title: string;
  markReadAll?: () => Promise<void>;
  loading?: boolean;
}> = (props) => {
  const { title, markReadAll, loading } = props;
  return (
    <WrapperHeader justify="space-between" align="center">
      <Body color="extSecondary" weight="regular">
        {title}
      </Body>
      {markReadAll && (
        <Tooltip title={t('Đánh dấu tất cả đã đọc')} placement="bottom">
          <ButtonIcon onClick={markReadAll} loading={loading} size={24}>
            <MarkAsReadAlternativeOutlined />
          </ButtonIcon>
        </Tooltip>
      )}
    </WrapperHeader>
  );
};
export interface MiniNotificationProps {
  onHide?: () => void;
}
export const MiniNotification: React.FunctionComponent<
  MiniNotificationProps
> = ({ onHide }: MiniNotificationProps) => {
  const {
    allNotifications,
    notifications,
    markReadNotification,
    markReadAll,
    markAllReadLoading,
  } = useNotification();
  const router = useRouter();
  const { epicOmni948 } = useTenantConfig();
  return (
    <Wrapper backgroundColor="white" borderRadius="l">
      {!!(epicOmni948 ? allNotifications : notifications).length && (
        <>
          <NotificationHeader
            title={t('THÔNG BÁO')}
            markReadAll={() => markReadAll(['noti', 'debt', 'order'])}
            loading={markAllReadLoading}
          />
          <NotificationList
            notifications={(epicOmni948
              ? allNotifications
              : notifications
            ).slice(0, 3)}
            onNotificationClick={async (noti) => {
              onHide && onHide();
              await markReadNotification(noti);
              onNotificationClick(noti, router);
            }}
          />
        </>
      )}

      <LastLinkWrapper
        padding="s8"
        align="center"
        justify="center"
        {...getTrackingData({
          isTrackContent: true,
          regionName: 'MiniNotification',
          contentName: 'viewNotificationFromMiniNotification',
          target: epicOmni948 ? 'PromotionAndUpdate' : 'Notification',
        })}
      >
        <Link
          {...(epicOmni948
            ? {
                href: SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI,
                as: SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI,
              }
            : {
                href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
                as: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
              })}
          onClick={onHide}
          prefetch={false}
        >
          {t('Xem tất cả thông báo')}
        </Link>
      </LastLinkWrapper>
    </Wrapper>
  );
};
